/**
 * Click-target info button rendered next to each step's type label.
 * Opens a Popover with three sections:
 *
 *   1. What it does — the existing detailed hint copy (`STEP_TYPE_HINTS`).
 *   2. Example scenario — a real survey-research pattern.
 *   3. Generated DATA(Q) — the script that scenario would emit.
 *
 * Replaces hover-only tooltip discovery for step types: the hint is now
 * pinned, scannable, and includes a copy-pasteable script snippet.
 */
import React from "react"
import { Popover } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons"
import { TransformStepType } from "stores/queryBuilderStore"
import { STEP_TYPE_HINTS, STEP_TYPE_LABELS } from "./stepTypeConfig"
import { STEP_TYPE_EXAMPLES } from "./stepHelpExamples"

interface StepHelpPopoverProps {
  type: TransformStepType
}

const StepHelpPopover: React.FC<StepHelpPopoverProps> = ({ type }) => {
  const example = STEP_TYPE_EXAMPLES[type]
  return (
    <Popover
      placement="rightTop"
      trigger="click"
      overlayClassName="qc-step-help-overlay"
      content={
        <div className="qc-step-help">
          <div className="qc-step-help__title">{STEP_TYPE_LABELS[type]}</div>
          <p className="qc-step-help__desc">{STEP_TYPE_HINTS[type]}</p>
          <div className="qc-step-help__section-label">Example</div>
          <p className="qc-step-help__scenario">{example.scenario}</p>
          <pre className="qc-step-help__script qc-mono">{example.script}</pre>
        </div>
      }
    >
      <button
        type="button"
        className="qc-step__help-btn"
        aria-label={`Help and example for ${STEP_TYPE_LABELS[type]}`}
        onClick={(e) => e.stopPropagation()}
      >
        <FontAwesomeIcon icon={faCircleQuestion} />
      </button>
    </Popover>
  )
}

export default StepHelpPopover
